import { useMutation } from "@tanstack/react-query";
import { apiClient } from "../service/tekkr-service";

interface Input {
    projectId: string;
    taskId: string;
}

export function useExecuteTaskMutation() {
    return useMutation({
        mutationFn: async (input: Input) => {
            const res = await apiClient.executeTask({
                params: {
                    projectId: input.projectId,
                    taskId: input.taskId,
                },
            });

            if (res.status !== 200) {
                throw new Error("Failed to execute task");
            }

            return res.body;
        },
    });
}
